
import {Vue, Component, Emit, Prop} from 'vue-property-decorator';

import {statisticsApi, materiaApi} from '@/api';
import Empty from '@/components/Empty/index.vue';

@Component({
    components: {
        Empty
    }
})
export default class Class_Authorize extends Vue {
    @Prop({
        default() {
            return {};
        }
    })
    private classInfo?: any;
    @Emit('closeModal') private closeModal() {}
    // 关联课程时
    @Emit('refreshCourseList') private refreshCourseList() {}
    // 新建班级并关联课程时
    @Emit('refreshClassList') private refreshClassList() {}
    // 关联教师
    // @Emit('visibleTeacher') visibleTeacher(data: any) {}
    //===================================data区域begin
    schoolId: string = '';
    pager: any = {
        default: {
            pagesize: 200,
            pagenum: 1,
            total: 0,
            rows: []
        },
        courseList: {
            pagesize: 200,
            pagenum: 1,
            total: 0,
            rows: []
        }
    };
    urlQueryParmas: any = {
        courseName: '',
        classId: ''
    };
    courseLoading: boolean = false;
    // 当前班级
    classId: any = '';
    className: any = '';
    // 课程表单表头
    columnsCourse: any = [
        {
            dataIndex: 'course.name',
            title: '课程名称',
            scopedSlots: {
                customRender: 'courseName'
            }
        }
    ];

    // 表格多选框选中的key
    selectedRowKeys: any = [];
    // 选中的班级数据
    selectClassItem: any = [];
    // 选中的课程数据
    selectCourseItem: any = [];
    // 处理的班级课程数据（用于右侧回显）
    classCourseList: any = [];
    // 表格滚动对象数据
    scroll: any = {
        y: 538
    };
    //===================================data区域end

    //===================================computed区域begin
    get rowSelection() {
        return {
            //onChange方法，rowSelection改变时触发
            onChange: (selectedRowKeys: any) => {
                //     //获取选中行的key元素，和下面selectedRowKeys属性配合使用，表示给rowSelection绑定一个v-model，为this.selectedRowKeys
                this.selectedRowKeys = selectedRowKeys;
                // console.log(selectedRowKeys);
                this.$nextTick(() => {
                    this.formatClassCourseList();
                });
            },
            selectedRowKeys: this.selectedRowKeys,
            onSelect: (record: any, selected: boolean, selectedRows: any) => {
                // console.log(record);
                if (selected) {
                    if (!this.selectClassItem.includes(this.classId)) {
                        this.selectClassItem.push(this.classId);
                    }
                    this.selectCourseItem.push(record);
                }
                if (!selected) {
                    for (let i = 0; i < this.selectCourseItem.length; i++) {
                        if (record.courseId == this.selectCourseItem[i].courseId && record.classId == this.selectCourseItem[i].classId) {
                            this.selectCourseItem.splice(i, 1);
                        }
                        for (let j = 0; j < this.selectClassItem.length; j++) {
                            if (record.classId == this.selectClassItem[j] && !this.selectCourseItem[i]?.classId == record.classId) {
                                this.selectClassItem.splice(j, 1);
                            }
                        }
                    }
                    if (this.selectCourseItem.length == 0) {
                        this.selectClassItem = [];
                    }
                }
                // console.log(this.selectClassItem, this.selectCourseItem);
            },
            // 用户手动选择/取消选择所有列的回调
            onSelectAll: (selected: boolean, selectedRows: any, changeRows: any) => {
                if (selected) {
                    if (!this.selectClassItem.includes(this.classId)) {
                        this.selectClassItem.push(this.classId);
                    }
                    selectedRows.forEach((el: any) => {
                        // console.log(el);
                        if (this.selectCourseItem.length > 0) {
                            if (!this.selectCourseItem.some((e: any) => e.courseId == el.courseId || el.courseInClass === true)) {
                                this.selectCourseItem.push(el);
                            }
                        } else {
                            if (el.courseInClass === false) {
                                this.selectCourseItem.push(el);
                            }
                        }
                    });
                } else {
                    for (let i = 0; i < changeRows.length; i++) {
                        for (let j = 0; j < this.selectCourseItem.length; j++) {
                            if (this.selectCourseItem[j].courseId == changeRows[i].courseId) {
                                this.selectCourseItem.splice(j, 1);
                            }
                        }
                    }
                    this.selectClassItem = [];
                }
                // console.log(this.selectClassItem, this.selectCourseItem);
            },
            // 表格默认状态
            getCheckboxProps: (record: any) => ({
                props: {
                    disabled: record.courseInClass ? true : false,
                    defaultChecked: record.courseInClass ? true : false
                }
            })
        };
    }
    //===================================computed区域end

    //===================================methods区域begin
    getBookList(value: any) {
        this.urlQueryParmas.courseName = value;
        this.getList();
    }
    // 处理选中的班级，课程数据，在右侧回显
    formatClassCourseList() {
        this.classCourseList = [];
        for (let i = 0; i < this.selectClassItem.length; i++) {
            this.classCourseList[i] = {classId: this.selectClassItem[i], className: this.className, course: []};
            for (let j = 0; j < this.selectCourseItem.length; j++) {
                this.classCourseList[i].course.push(this.selectCourseItem[j]);
            }
        }
        // console.log(this.classCourseList);
    }
    // 处理表格滚动
    scrollOrNot() {
        this.$nextTick(() => {
            // console.log(document.querySelectorAll('.ant-table-body')[1].clientHeight);
            let height = document.querySelectorAll('.ant-table-body')[1]?.clientHeight;
            if (height < 538) {
                this.scroll = {};
            } else {
                this.scroll = {
                    y: 538
                };
            }
        });
    }

    // 右侧取消课程
    onCancel(itemCourse: any) {
        // console.log(itemCourse);
        for (let i = 0; i < this.selectedRowKeys.length; i++) {
            if (itemCourse._id == this.selectedRowKeys[i]) {
                this.selectedRowKeys.splice(i, 1);
            }
        }
        for (let j = 0; j < this.classCourseList.length; j++) {
            for (let k = 0; k < this.classCourseList[j].course?.length; k++) {
                if (itemCourse.courseId == this.classCourseList[j].course[k].courseId) {
                    this.classCourseList[j].course.splice(k, 1);
                    this.selectCourseItem.splice(itemCourse.courseId, 1);
                    if (this.classCourseList[j].course.length == 0) {
                        this.classCourseList[j] = [];
                        this.selectClassItem.splice(itemCourse.classId, 1);
                    }
                    // console.log(this.selectClassItem);
                }
            }
        }
        // console.log(this.classCourseList);
    }
    getList() {
        let me = this;
        me.courseLoading = true;
        let schoolId = me.schoolId;
        let titleOrDesc = me.urlQueryParmas.courseName;
        statisticsApi.getSchoolDistributionCourse({
            context: me,
            urlQueryParmas: {schoolId, titleOrDesc},
            success: (data: any, parameters: any) => {
                if (data.code === 0) {
                    // console.log(data.data);
                    me.pager.courseList.rows = data.data;
                    for (let i = 0; i < data.data.length; i++) {
                        data.data[i].courseInClass = false;
                        for (let j = 0; j < data.data[i].associatedClass.length; j++) {
                            if (data.data[i].associatedClass[j].classId == me.classId) {
                                data.data[i].courseInClass = true;
                            }
                        }
                    }
                    me.scrollOrNot();
                }
                me.courseLoading = false;
            },
            error: (error: any, message: string, parameters: any) => {
                me.$message.error(message);
                me.courseLoading = false;
            }
        });
    }
    handleCancel() {
        this.$emit('closeModal');
    }
    handleOk() {
        let me = this;
        if (me.selectCourseItem.length == 0) {
            me.$message.error('当前未选中课程');
            return;
        }
        let courseList = [];
        for (let i = 0; i < me.classCourseList[0].course.length; i++) {
            courseList.push(me.classCourseList[0].course[i].courseId);
        }
        let formData = {
            classIdList: [me.classCourseList[0].classId],
            courseIdList: courseList,
            schoolId: me.schoolId,
            associatedType: 'byAdmin'
        };
        // console.log(me.classCourseList);
        // console.log(courseList);
        materiaApi.saveOutAuthorization({
            context: me,
            data: formData,
            success(data: any, parameters: any) {
                me.$message.success('操作成功!');
                // console.log(me.classCourseList);
                // console.log(data.data);
                // return;
                me.$emit('openTeacher', me.classCourseList);
                me.handleCancel();
                me.$emit('refreshCourseList');
                me.$emit('refreshClassList');
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
            }
        });
    }
    //===================================methods区域end

    created() {
        if (this.$route.query) {
            this.classId = this.$route.query.classId;
            this.className = this.$route.query.className;
        }
        if (this.classInfo.classId) {
            this.classId = this.classInfo.classId;
            this.className = this.classInfo.className;
        }
        let state = this.$app.getState();
        this.schoolId = state.schoolId;
        // console.log(this);
        this.getList();
    }
}
